import AnonOfferedReplyDto from "@/models/AnonBookingRoleWorkers/AnonOfferedReplyDto";
import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerBookingOfferRequest extends BaseUpdateRequest
{ 
    replies: AnonOfferedReplyDto[];
}